export default "__VITE_ASSET__6df50417__"